/** @format */

import { Chain, Environment } from '@shared/data-access/interfaces';
import { CreditAccount, PointHistory } from '@my-account/data-access/interfaces';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpService, MyAccountAnalyticsService, Store } from '@shared/data-access/services';

import { Injectable } from '@angular/core';
import { LoyaltyBalance } from '@scorecard/data-access';

import { MyAccountErrorLogKeys } from '@shared/data-access/enums';

@Injectable({
	providedIn: 'root'
})
export class PointsService {
	constructor(
		private chain: Chain,
		private environment: Environment,
		private httpService: HttpService,
		private store: Store,
		private myAccountAnalyticsService: MyAccountAnalyticsService
	) {}

	getPointSummary(): Observable<LoyaltyBalance> {
		const url = `${this.environment.baseUrls.pointService}/v${this.chain.apiVersion}/pointSummary/${this.chain.chainIdentifierAbbr}`;

		return this.httpService
			.get(url, 0, {
				withCredentials: true,
				useApiAuth: true
			})
			.pipe(
				map((result: LoyaltyBalance) => {
					this.store.set('LOYALTY_BALANCE', result);
					return result;
				}),
				catchError((err) => {
					const errorLoyaltyBalance: LoyaltyBalance = {
						currentPointBalance: 0,
						rewardAmount: 0,
						error: true
					};
					this.store.set('LOYALTY_BALANCE', errorLoyaltyBalance);
					this.myAccountAnalyticsService.generateLogError(
						MyAccountErrorLogKeys.MYACCOUNT_POINT_SERVICE,
						'Failed to get Point Summary from Point Service',
						err
					);
					return throwError(() => err.status);
				})
			);
	}

	getPointsHistory(): Observable<PointHistory[]> {
		const url = `${this.environment.baseUrls.pointService}/v${this.chain.apiVersion}/PointsHistory/${this.chain.chainIdentifierAbbr}`;

		return this.httpService
			.get<PointHistory[]>(url, 0, {
				withCredentials: true,
				useApiAuth: true
			})
			.pipe(
				catchError((err) => {
					this.myAccountAnalyticsService.generateLogError(
						MyAccountErrorLogKeys.MYACCOUNT_POINT_SERVICE,
						'Failed to get Points History from Point Service',
						err
					);
					return throwError(() => err);
				})
			);
	}

	creditAccountV3(request: CreditAccount) {
		const url = `${this.environment.baseUrls.pointService}/v3/CreditAccount`;
		return this.httpService
			.post(url, request, { withCredentials: true, useApiAuth: true, observe: 'response' })
			.pipe(
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				map((data) => 200),
				catchError((err) => {
					this.myAccountAnalyticsService.generateLogError(
						MyAccountErrorLogKeys.MYACCOUNT_POINT_SERVICE,
						'Failed to get Credit Account from Point Service',
						err
					);
					return of(err.status);
				})
			);
	}
}
